"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBeforeUnloadTracker = exports.getTracker = exports.setTracker = void 0;
var tracker;

var setTracker = function setTracker(_tracker, override) {
  if (tracker && !override) {
    throw new Error('Attempting to override an existing usage tracker.');
  }

  tracker = _tracker;
};

exports.setTracker = setTracker;

var getTracker = function getTracker() {
  if (!tracker) {
    throw new Error('No tracker was set. Make sure setTracker was called.');
  }

  return tracker;
};

exports.getTracker = getTracker;

var getBeforeUnloadTracker = function getBeforeUnloadTracker() {
  return getTracker().clone({
    isBeforeUnload: true
  });
};

exports.getBeforeUnloadTracker = getBeforeUnloadTracker;